import State from "../lib/State";

import * as PIXI from "pixi.js";
import gsap from "gsap";
import signals from "signals";
import ServiceLocator from "../ServiceLocator";

import FontFaceObserver from "fontfaceobserver";
import { ISoundLoadGroup, track_id } from "../service/AudioManager";
import { device_orientation_type } from "../service/DeviceOrientation";
import Button from "../lib/Button";


export default class PreloaderState extends State
{
    // #region Attributes //

    // private:

    private _resources: PIXI.utils.Dict<PIXI.LoaderResource> = null;

    private _root: PIXI.Container = null;

    private _bg: PIXI.Sprite = null;
    private _gameLogo: PIXI.Sprite = null;

    private _loadingBarContainer: PIXI.Container = null;
    private _loadingBarMask: PIXI.Graphics = null;

    private _arrFontFaceObserver: Array<FontFaceObserver> = null;
    private _loadedFountCount: number = null;

    private _loadingStartTime: number = null;

    private _gameLogoWrapper: PIXI.Container = null;
    
    // Signals.
    private _onComplete: signals.Signal = new signals.Signal();

    // #endregion //


    // #region Properties //

    // Signals.
    public get onComplete(): signals.Signal { return this._onComplete; }

    // #endregion //


    // #region Methods //

    // public:

    public constructor() 
    { 
        super(); 
    }

    public onEnter( params: Object = null ): void
    {
        this._loadingStartTime = Date.now();

        this._resources = {};
        Object.assign( this._resources, PIXI.Loader.shared.resources );

        this._root = new PIXI.Container();
        ServiceLocator.app.root.addChild( this._root );

        this._bg = new PIXI.Sprite( this._resources.bg.texture );
        this._bg.anchor.set( 0.5 );
        this._bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( this._bg );

        this._gameLogoWrapper = new PIXI.Container();
        this._root.addChild( this._gameLogoWrapper );
        //
        this._gameLogo = new PIXI.Sprite( this._resources.game_logo.texture );
        this._gameLogo.position.set( ServiceLocator.app.width * 0.5, 140 );
        this._gameLogo.anchor.set( 0.5, 0 );
        this._gameLogoWrapper.addChild( this._gameLogo );
        //
        /*const kArrSparkPos: Array<number> = [ 
            80, 226,
            48, 216,
            406, 231,
            265, 14,
            436, 212 ];
        const kArrSparkSize: Array<number> = [ 38, 18, 38, 28, 18 ];
        const kArrSparkId: Array<string> = [
            "spark_04",
            "spark_05",
            "spark_05",
            "spark_02",
            "spark_03" ];
        for ( let i: number = 0; i < 5; ++i )
        {
            let spark: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources[ kArrSparkId[ i ] ].texture );
            spark.anchor.set( 0.5 );
            spark.scale.set( kArrSparkSize[ i ] / spark.texture.width );
            spark.position.set( kArrSparkPos[ i * 2 ] + 90, kArrSparkPos[ i * 2 + 1 ] + 150 );
            this._gameLogoWrapper.addChild( spark );

            let sparkTween: gsap.core.Tween = gsap.from( spark.scale, { x: spark.scale.x * 0.8, y: spark.scale.y * 0.8, duration: 0.4 + Math.random() * 0.4, repeat: -1, yoyo: true, ease: "sine.inOut" } );
            sparkTween.progress( Math.random() );
        }*/

        this._loadingBarContainer = new PIXI.Container();
        this._loadingBarContainer.position.set( ServiceLocator.app.width * 0.5, 880 );
        this._root.addChild( this._loadingBarContainer );

        let loadingBarBase: PIXI.Sprite = new PIXI.Sprite( this._resources.loading_bar_base.texture );
        loadingBarBase.anchor.set( 0.5, 0.5 );
        this._loadingBarContainer.addChild( loadingBarBase );

        let loadingBar: PIXI.Container = new PIXI.Container();
        this._loadingBarContainer.addChild( loadingBar );
        //
        let bar: PIXI.Sprite = new PIXI.Sprite( this._resources.loading_bar.texture );
        bar.anchor.set( 0, 0.5 );
        bar.position.set( -bar.width * 0.5, /*-5*/0 );
        loadingBar.addChild( bar );
        //
        this._loadingBarMask = new PIXI.Graphics();
        this._loadingBarMask.position.set( bar.x, bar.y - bar.height * 0.5 );
        this._loadingBarMask.beginFill( 0xff3300 );
        this._loadingBarMask.drawRect( 0, 0, bar.width, bar.height );
        this._loadingBarMask.endFill();
        this._loadingBarMask.scale.x = 0;
        loadingBar.addChild( this._loadingBarMask );
        loadingBar.mask = this._loadingBarMask;
        
        let loadingBarFront: PIXI.Sprite = new PIXI.Sprite( this._resources.loading_bar_front.texture );
        loadingBarFront.anchor.set( 0.5, 0.5 );
        this._loadingBarContainer.addChild( loadingBarFront );

        this._loadedFountCount = 0;
        this._arrFontFaceObserver = [];
        const kArrFontId: Array<string> = [ "asap_bold", "asap_extrabold", "asap_regular" ];
        for ( let fontId of kArrFontId )
        {
            let ffo: FontFaceObserver = new FontFaceObserver( fontId );
            ffo.load( null, 10000 ).then( () => { this._loadedFountCount += 1; } ).catch( () => { this._loadedFountCount += 1; } );
            this._arrFontFaceObserver.push( ffo );
        }

        // Preload game assets.
        const kResolutionSuffix = "@2x";
        PIXI.Loader.shared.reset();
        PIXI.Loader.shared.defaultQueryString = ServiceLocator.saved.data.version.toString();
        //
        PIXI.Loader.shared
            .add( "emitter_sparks", "resources/emitter/sparks.json" )
            .add( "emitter_crown", "resources/emitter/crown.json" )
            //
            .add( "deck_gb", "resources/img/gameplay/deck_gb.json" )
            .add( "deck_ry", "resources/img/gameplay/deck_ry.json" )
            .add( "deck_s", "resources/img/gameplay/deck_s.json" )
            //
            .add( "button_back", "resources/img/common/button_back@2x.png" )
            .add( "button_back_pressed", "resources/img/common/button_back_pressed@2x.png" )
            .add( "settings_toggle_base", "resources/img/common/settings/settings_toggle_base@2x.png" )
            .add( "settings_toggle_base_no_home", "resources/img/common/settings/settings_toggle_base_no_home@2x.png" )
            .add( "button_settings", "resources/img/common/settings/button_settings@2x.png" )
            .add( "button_settings_pressed", "resources/img/common/settings/button_settings_pressed@2x.png" )
            .add( "settings_button_music", "resources/img/common/settings/button_music_on@2x.png" )
            .add( "settings_button_music_pressed", "resources/img/common/settings/button_music_on_pressed@2x.png" )
            .add( "settings_button_music_off", "resources/img/common/settings/button_music_off@2x.png" )
            //.add( "button_music_off_pressed", "resources/img/common/button_music_off_pressed@2x.png" )
            .add( "settings_button_sfx", "resources/img/common/settings/button_sound_on@2x.png" )
            .add( "settings_button_sfx_pressed", "resources/img/common/settings/button_sound_on_pressed@2x.png" )
            .add( "settings_button_sfx_off", "resources/img/common/settings/button_sound_off@2x.png" )
            //.add( "button_sfx_off_pressed", "resources/img/common/button_sound_off_pressed@2x.png" )
            .add( "settings_button_home", "resources/img/common/settings/button_home@2x.png" )
            .add( "settings_button_home_pressed", "resources/img/common/settings/button_home_pressed@2x.png" )
            .add( "settings_button_tutorial", "resources/img/common/settings/button_tutorials@2x.png" )
            .add( "settings_button_tutorial_pressed", "resources/img/common/settings/button_tutorials_pressed@2x.png" )
            .add( "avatar_you", "resources/img/common/avatar/you@2x.png" )
            .add( "avatar_unknown", "resources/img/common/avatar/unknown@2x.png" );
        for ( let i: number = 0; i < 12; ++i )
        {
            PIXI.Loader.shared.add( "avatar_" + i.toString(), "resources/img/common/avatar/" + i.toString() + "@2x.png" );
        }
        PIXI.Loader.shared
            .add( "popup_base", "resources/img/popup/base@2x.png" )
            .add( "popup_base_alt", "resources/img/popup/base_alt@2x.png" )
            .add( "popup_button_green", "resources/img/popup/button_green@2x.png" )
            .add( "popup_button_red", "resources/img/popup/button_red@2x.png" )
            //
            .add( "button_classic_mode", "resources/img/lobby/button_classic_mode@2x.png" )
            .add( "button_classic_mode_pressed", "resources/img/lobby/button_classic_mode_pressed@2x.png" )
            .add( "button_play_with_friends", "resources/img/lobby/button_play-with-friends@2x.png" )
            .add( "button_play_with_friends_pressed", "resources/img/lobby/button_play-with-friends_pressed@2x.png" );
        for ( let i: number = 0; i < 21; ++i )
        {
            PIXI.Loader.shared.add( "button_classic_mode_" + i.toString(), "resources/img/lobby/classic_mode_anim/" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "button_friends_mode_" + i.toString(), "resources/img/lobby/friends_mode_anim/" + i.toString() + ".png" );
        }
        //
        PIXI.Loader.shared
            .add( "button_play", "resources/img/play_with_friends/button_play@2x.png" )
            .add( "button_copy", "resources/img/play_with_friends/button_copy@2x.png" )
            .add( "button_copy_pressed", "resources/img/play_with_friends/button_copy_pressed@2x.png" )
            .add( "url_base", "resources/img/play_with_friends/link_multiplied_base@2x.png" )
            //
            .add( "mm_left_triangle", "resources/img/matchmaking/blue_triangle@2x.png" )
            .add( "mm_top_triangle", "resources/img/matchmaking/green_triangle@2x.png" )
            .add( "mm_right_triangle", "resources/img/matchmaking/yellow_triangle@2x.png" )
            .add( "mm_bottom_triangle", "resources/img/matchmaking/red_triangle@2x.png" )
            .add( "magnifying_glass", "resources/img/matchmaking/magnifying_glass@2x.png" )
            .add( "mm_flash", "resources/img/matchmaking/flash@2x.png" )
            .add( "mm_vs", "resources/img/matchmaking/vs@2x.png" )
            .add( "mm_godrays", "resources/img/matchmaking/godrays@2x.png" );
        for ( let i: number = 0; i < 6; ++i )
        {
            PIXI.Loader.shared.add( "mm_banner_sparks_" + i.toString(), "resources/img/matchmaking/banner_sparks/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 5; ++i )
        {
            PIXI.Loader.shared.add( "mm_flash_sparks_" + i.toString(), "resources/img/matchmaking/flash_sparks/" + i.toString() + ".png" );
        }
            //
        PIXI.Loader.shared
            .add( "game_bg", "resources/img/gameplay/background@2x.png" )
            .add( "spotlight", "resources/img/gameplay/spotlight@2x.png" )
            .add( "deck_shadow", "resources/img/gameplay/deck_shadow@2x.png" )
            .add( "play_order_arrow", "resources/img/gameplay/play_order_arrow@2x.png" )
            .add( "play_order_arrow_red", "resources/img/gameplay/play_order_arrow_red@2x.png" )
            .add( "play_order_arrow_green", "resources/img/gameplay/play_order_arrow_green@2x.png" )
            .add( "play_order_arrow_blue", "resources/img/gameplay/play_order_arrow_blue@2x.png" )
            .add( "play_order_arrow_yellow", "resources/img/gameplay/play_order_arrow_yellow@2x.png" )
            .add( "card_shade", "resources/img/gameplay/card_shade.png" )
            .add( "card_highlight", "resources/img/gameplay/card_highlight@2x.png" )
            .add( "player_arrow", "resources/img/gameplay/player_arrow@2x.png" )
            .add( "score_counter", "resources/img/gameplay/score_counter@2x.png" )
            .add( "comic_bubble", "resources/img/gameplay/bubble@2x.png" )
            .add( "hand", "resources/img/gameplay/hand@2x.png" )
            .add( "winner_glow", "resources/img/gameplay/winner_glow@2x.png" )
            //
            .add( "special_glow", "resources/img/gameplay/special/glow@2x.png" )
            .add( "special_icon_skip_shadow", "resources/img/gameplay/special/icon_skip_shadow@2x.png" )
            .add( "special_icon_reverse_shadow", "resources/img/gameplay/special/icon_reverse_shadow@2x.png" )
            .add( "special_icon_draw-2_shadow", "resources/img/gameplay/special/icon_draw-2_shadow@2x.png" );
        const kArrColorId: Array<string> = [ "blue", "red", "green", "yellow" ];
        for ( let i: number = 0; i < 4; ++i )
        {
            PIXI.Loader.shared.add( "special_icon_skip_" + kArrColorId[ i ], "resources/img/gameplay/special/icon_skip_" + kArrColorId[ i ] + "@2x.png" )
                .add( "special_icon_reverse_" + kArrColorId[ i ], "resources/img/gameplay/special/icon_reverse_" + kArrColorId[ i ] + "@2x.png" )
                .add( "special_icon_draw-2_" + kArrColorId[ i ], "resources/img/gameplay/special/icon_draw-2_" + kArrColorId[ i ] + "@2x.png" );
        }
        //
        for ( let i: number = 0; i < 12; ++i )
        {
            PIXI.Loader.shared.add( "compass_idle_anim_" + i.toString(), "resources/img/gameplay/compass/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 19; ++i )
        {
            PIXI.Loader.shared.add( "tentacle_in_anim_" + i.toString(), "resources/img/gameplay/tentacle/in/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 35; ++i )
        {
            PIXI.Loader.shared.add( "tentacle_idle_anim_" + i.toString(), "resources/img/gameplay/tentacle/idle/" + i.toString() + ".png" );
        }
        //
        for ( let i: number = 0; i < 29; ++i )
        {
            PIXI.Loader.shared.add( "sparks_anim_" + i.toString(), "resources/img/gameplay/color_selection/sparks_anim/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 27; ++i )
        {
            PIXI.Loader.shared.add( "frame_anim_" + i.toString(), "resources/img/gameplay/color_selection/frame_anim/" + i.toString() + ".png" );
        }
        PIXI.Loader.shared
            .add( "spark_01", "resources/img/gameplay/color_selection/spark_02@2x.png" )
            .add( "color_selection_golden_frame", "resources/img/gameplay/color_selection/golden_frame.png" )
            .add( "color_selection_hightlight", "resources/img/gameplay/color_selection/color_select_highlight@2x.png" )
            .add( "color_selection_blue_eight", "resources/img/gameplay/color_selection/color_select_blue_eight@2x.png" )
            .add( "color_selection_red_eight", "resources/img/gameplay/color_selection/color_select_red_eight@2x.png" )
            .add( "color_selection_green_eight", "resources/img/gameplay/color_selection/color_select_green_eight@2x.png" )
            .add( "color_selection_yellow_eight", "resources/img/gameplay/color_selection/color_select_yellow_eight@2x.png" )
            .add( "color_selection_blue_wild", "resources/img/gameplay/color_selection/color_select_blue_wild@2x.png" )
            .add( "color_selection_red_wild", "resources/img/gameplay/color_selection/color_select_red_wild@2x.png" )
            .add( "color_selection_green_wild", "resources/img/gameplay/color_selection/color_select_green_wild@2x.png" )
            .add( "color_selection_yellow_wild", "resources/img/gameplay/color_selection/color_select_yellow_wild@2x.png" );
        //
        PIXI.Loader.shared
            .add( "godrays", "resources/img/gameplay/result/godrays@2x.png" )
            .add( "results_final_base", "resources/img/gameplay/result/results_final_base@2x.png" )
            .add( "results_round_base", "resources/img/gameplay/result/results_round_base@2x.png" )
            .add( "results_final_highlight_winner", "resources/img/gameplay/result/final_highlight_winner@2x.png" )
            .add( "results_round_highlight_winner", "resources/img/gameplay/result/round_highlight_winner@2x.png" )
            .add( "results_round_highlight_row", "resources/img/gameplay/result/highlight_row@2x.png" )
            .add( "badge_1st_final", "resources/img/gameplay/result/badge_1st_final@2x.png" )
            .add( "badge_1st_round", "resources/img/gameplay/result/badge_1st_round.png" )
            .add( "crown", "resources/img/gameplay/result/crown@2x.png" )
            .add( "button_replay", "resources/img/gameplay/result/button_replay@2x.png" )
            .add( "button_replay_pressed", "resources/img/gameplay/result/button_replay_pressed@2x.png" )
            .add( "button_home", "resources/img/gameplay/result/button_home@2x.png" )
            .add( "button_home_pressed", "resources/img/gameplay/result/button_home_pressed@2x.png" )
            .add( "eliminated_stamp", "resources/img/gameplay/result/eliminated_stamp@2x.png" );
        for ( let i: number = 0; i < 11; ++i )
        {
            PIXI.Loader.shared.add( "confetti_" + i.toString(), "resources/img/gameplay/result/confetti/" + i.toString() + "@2x.png" );
        }
        //
        PIXI.Loader.shared.add( "tut_bg", "resources/img/tutorial/bg@2x.png" )
            .add( "tut_arrow_left", "resources/img/tutorial/arrow_left@2x.png" )
            .add( "tut_arrow_right", "resources/img/tutorial/arrow_right@2x.png" )
            .add( "tut_button_continue", "resources/img/tutorial/button_continue@2x.png" )
            .add( "tut_button_continue_pressed", "resources/img/tutorial/button_continue_pressed@2x.png" )
            .add( "tut_header_base", "resources/img/tutorial/header_base@2x.png" )
            .add( "tut_dot", "resources/img/tutorial/tut_dot@2x.png" )
            .add( "tut_dot_base", "resources/img/tutorial/tut_dot_base@2x.png" );
        for ( let i = 0; i < 4; ++i )
        {
            PIXI.Loader.shared.add( "tut_module_" + i.toString(), "resources/img/tutorial/base/" + i.toString() + kResolutionSuffix + ".png" )
        }
        //
        PIXI.Loader.shared.add( "button_on", "resources/img/button_on.png" )
            .add( "button_pressed", "resources/img/button_pressed.png" )
            .add( "transparent", "resources/img/transparent.png" )
            //
            .add( "game_config", "resources/json/game_config.json" );
        //
        PIXI.Loader.shared.onComplete.once( this._onLoader_Complete, this );
        PIXI.Loader.shared.onProgress.add( this._onLoader_Progress, this );
        PIXI.Loader.shared.load();

        // Create sound load groups.
        const kArrSoundLoadGroup: Array<ISoundLoadGroup> = [ 
            /*{ // music.
                arrExtension: [ "mp3" ],
                trackId: track_id.MUSIC,
                basePath: "resources/img/music/",
                arrName: [ "track_0" ]
            },*/
            { // sfx.
                arrExtension: [ "mp3" ],
                trackId: track_id.SFX,
                basePath: "resources/sound/",
                arrName: [ 
                    "ui_button_click",
                    "deal_flip_0",
                    "deal_flip_1",
                    "deal_flip_2",
                    "deal_flip_3",
                    "shuffle_0",
                    "shuffle_1",
                    "shuffle_2",
                    "slide_0",
                    "slide_1",
                    "slide_2",
                    "slide_3",
                    "dealing_cards",
                    "end_round",
                    "final_result",
                    "wild_card",
                    "talling_points",
                    "win_round",
                    "wildcard_selection_in",
                    "wildcard_selection_out",
                    "reverse_special",
                    "skip_special",
                    "draw_two_special",
                    "game_ready" ] 
            } ];
        ServiceLocator.audio.load( kArrSoundLoadGroup );
    }

        private _onLoader_Complete( loader: PIXI.Loader, resources: PIXI.utils.Dict<PIXI.LoaderResource> ): void
        {
            if ( this._loadedFountCount == this._arrFontFaceObserver.length )
            {
                Object.assign( ServiceLocator.resources, resources );
                loader.reset();

                window.setTimeout( () => { this._onComplete.dispatch( this._gameLogoWrapper ); }, Math.max( 500, 2000 - ( Date.now() - this._loadingStartTime ) ) ); // show full bar.
            }
            else
            {
                window.setTimeout( this._onLoader_Complete.bind( this ), 500 );
            }
        }

        private _onLoader_Progress( loader: PIXI.Loader ): void
        {
            this._loadingBarMask.scale.x = loader.progress / 100;
        }

    public onLeave(): void
    {
        // Cleanup events.
        this._onComplete.dispose();
        this._onComplete = null;

        ServiceLocator.app.root.removeChild( this._root );
        this._root.destroy( { children: true } );
        this._root = null;

        super.onLeave();
    }

    // #endregion //
}